<template>
  <v-container fluid class="pa-0 white">
    <div style="overflow-x: auto">
      <v-data-table
        mobile-breakpoint="0"
        :headers="headers"
        :items="filteredExpenses"
        :items-per-page="15"
        :options.sync="options"
        class="elevation-0"
      >
        <template v-slot:header>
          <tr>
            <th v-for="(header, idx) in headers" :key="`header-${idx}`">
              <v-text-field
                v-if="header.value != 'action'"
                dense
                class="ma-2"
                rounded
                v-model="filter[header.value]"
                placeholder="filter"
                solo-inverted
                hide-details
                flat
              ></v-text-field>
            </th>
          </tr>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <a
            @click="
              $router
                .push({
                  name: 'ExpenseDetail',
                  params: { id: item.id },
                })
                .catch(() => {})
            "
            >{{ item.id }}</a
          >
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <span class="mr-1">$</span
          ><span>{{ convertToCleanNumber(item.amount) }}</span>
        </template>
        <template v-slot:[`item.typeId`]="{ item }">
          <v-autocomplete
            :rules="[(v) => !!v || 'Required']"
            :items="types"
            item-text="displayName"
            item-value="id"
            dense
            rounded
            outlined
            hide-details
            label="Expense Type"
            v-model="item.typeId"
            required
          ></v-autocomplete>
        </template>
        <template v-slot:[`item.vendorId`]="{ item }">
          <v-autocomplete
            :rules="[(v) => !!v || 'Required']"
            :items="vendors"
            item-text="name"
            item-value="id"
            dense
            rounded
            outlined
            hide-details
            label="Vendor"
            v-model="item.vendorId"
            required
          ></v-autocomplete>
        </template>
        <template v-slot:[`item.paymentMethodId`]="{ item }">
          <v-autocomplete
            :rules="[(v) => !!v || 'Required']"
            :items="paymentMethods"
            item-text="displayName"
            item-value="id"
            dense
            rounded
            outlined
            hide-details
            label="Payment Method"
            v-model="item.paymentMethodId"
            required
          ></v-autocomplete>
        </template>
        <template v-slot:[`item.transactionDate`]="{ item }">
          {{ convertToDate(item.transactionDate, false) }}
        </template>
        <template v-slot:[`item.createdBy`]="{ item }">
          {{ getUserName(item.createdBy) }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            icon
            color="primary"
            @click="updateExpense(item)"
            :loading="isLoading == item.id"
            :disabled="!(item.typeId && item.vendorId && item.paymentMethodId)"
            ><i class="fas fa-save"></i
          ></v-btn>
        </template>
      </v-data-table>
    </div>
    <general-dialog
      v-model="deleteDialog"
      :dialog="deleteDialog"
      :options="deleteOptions"
    ></general-dialog>
  </v-container>
</template>
<script>
import eventBus from "@/js/event-bus.js";
import backendService from "@/services/backend-service";
import GeneralDialog from "@/components/GeneralDialog.vue";
import generalMixin from "@/js/general-mixin";
export default {
  name: "ExpenseList",
  components: {
    "general-dialog": GeneralDialog,
  },
  mixins: [generalMixin],
  mounted: function () {
    eventBus.$on("generateCsv", this.generateCsv);
  },
  props: {
    expenses: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Id",
          value: "id",
          width: 50,
        },
        { text: "Amount", value: "amount", width: 100 },
        { text: "Type", value: "typeId", width: 200 },
        { text: "Vendor", value: "vendorId", width: 200 },
        { text: "Payment Method", value: "paymentMethodId", width: 200 },
        { text: "Transaction Date", value: "transactionDate", width: 150 },
        { text: "Description", value: "description", width: 200 },
        { text: "Created By", value: "createdBy", width: 150 },
        { text: "Action", value: "action", width: 50 },
      ],
      deleteDialog: false,
      deleteOptions: {
        btnText: "Yes",
        message: "This action is not revertable!",
        title: "Are you sure you want to delete this customer?",
      },

      isLoading: -1,
    };
  },
  computed: {
    filteredExpenses() {
      let expenses = this.expenses;
      for (let key in this.filter) {
        let searchStr = this.filter[key].trim().toLowerCase();
        let header = this.headers.find((header) => header.value == key);
        if (searchStr && searchStr.length) {
          expenses = expenses.filter((e) => {
            let str = this.getDataText(header, e);
            return str
              .toString()
              .trim()
              .toLowerCase()
              .includes(this.filter[key].toLowerCase());
          });
        }
      }
      return expenses;
    },
    vendors() {
      return this.$store.getters["vendors"];
    },
    paymentMethods() {
      if (
        this.$store.getters["dropdownToOptions"] &&
        this.$store.getters["dropdownToOptions"]["expensePaymentMethod"]
      )
        return this.$store.getters["dropdownToOptions"]["expensePaymentMethod"]
          .options;
      return [];
    },
    types() {
      if (
        this.$store.getters["dropdownToOptions"] &&
        this.$store.getters["dropdownToOptions"]["expenseType"]
      )
        return this.$store.getters["dropdownToOptions"]["expenseType"].options;
      return [];
    },
    options: {
      get() {
        return this.$store.getters["interactStore/expenseOptions"];
      },
      set(val) {
        this.$store.commit("interactStore/setExpenseOptions", val);
      },
    },
    filter: {
      get() {
        return this.$store.getters["interactStore/expenseFilter"];
      },
      set(val) {
        this.$store.commit("interactStore/setExpenseFilter", val);
      },
    },
  },
  methods: {
    generateCsv() {
      let headerStr =
        "Id;Amount in $;Type;Vendor;Payment Method;Transaction Date;Description;Created By";
      let csvContent = "";
      csvContent += headerStr + "\r\n";

      for (let i = 0; i < this.expenses.length; i++) {
        const expense = this.expenses[i];
        let rowStr =
          `${expense.id};${expense.amount};${this.getOptionName(
            expense.typeId
          )};${this.getOptionName(expense.vendorId)};${this.getOptionName(
            expense.paymentMethodId
          )};` +
          `${this.convertToDate(expense.transactionDate, false)};"${
            expense.description
          }";${expense.createdByObj.first} ${expense.createdByObj.last}`;
        csvContent += rowStr + "\r\n";
      }
      let blob = new Blob([csvContent], { type: "text/plain" });
      let url = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `expense-list.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getDataText(header, expense) {
      if (header.value == "id") {
        return expense.id.toString();
      } else if (header.value == "amount") {
        return expense.amount;
      } else if (header.value == "typeId") {
        return this.getOptionName(expense.typeId);
      } else if (header.value == "vendorId") {
        return this.getOptionName(expense.vendorId);
      } else if (header.value == "description") {
        return expense.description;
      } else if (header.value == "paymentMethodId") {
        return this.getOptionName(expense.paymentMethodId);
      } else if (header.value == "transactionDate") {
        return this.convertToDate(expense.transactionDate, false);
      } else if (header.value == "createdBy") {
        return `${expense.createdByObj.first} ${expense.createdByObj.last}`;
      } else {
        return "";
      }
    },
    updateExpense(expense) {
      this.isLoading = expense.id;
      backendService
        .updateExpenseBasic(expense)
        .then(() => {
          this.timer(1000).then(() => {
            this.isLoading = -1;
            this.successSnackbar("Successfully updated expense");
            this.$emit("update");
          });
        })
        .catch(() => {
          this.timer(1000).then(() => {
            this.isLoading = -1;
            this.errorSnackbar("Ops! Something is not right");
          });
        });
    },
  },
  destroyed: function () {
    eventBus.$off("generateCsv");
  },
};
</script>
